import './styles.scss';

import { SwapRightOutlined } from '@ant-design/icons';
import { InputNumber } from 'antd';
import React from 'react';

interface NumberRangeProps {
  value?: [number | null, number | null];
  placeholder?: string[];
  onChange?: (value: [number | null, number | null]) => void;
  disabled?: boolean;
}

interface CompositeNumberRangeProps extends Omit<NumberRangeProps, 'value' | 'onChange'> {
  value?: [[number | null, number | null], number | null];
  onChange?: (value: [[number | null, number | null], number | null]) => void;
}

const NumberRange: React.FC<NumberRangeProps> & {
  Composite: React.FC<CompositeNumberRangeProps>;
} = ({ value = [null, null], placeholder, onChange, disabled }) => {
  const changeStart = (val: number | null) => onChange?.([val, value[1]]);
  const changeEnd = (val: number | null) => onChange?.([value[0], val]);

  return (
    <div className={'ant-input-number-range-wrapper'}>
      <InputNumber
        variant={'borderless'}
        className={'range-input'}
        value={value[0]}
        placeholder={placeholder?.[0]}
        onChange={changeStart}
        disabled={disabled}
        controls={false}
      />
      <div className={'range-separator'}>
        <SwapRightOutlined />
      </div>
      <InputNumber
        variant={'borderless'}
        className={'range-input'}
        value={value[1]}
        placeholder={placeholder?.[1]}
        onChange={changeEnd}
        disabled={disabled}
        controls={false}
      />
    </div>
  );
};

const CompositeNumberRange: React.FC<CompositeNumberRangeProps> = ({
  value = [[null, null], null],
  placeholder,
  onChange,
  disabled,
}) => {
  const [range, extra] = value;

  const changeStart = (val: number | null) => onChange?.([[val, range[1]], extra]);
  const changeEnd = (val: number | null) => onChange?.([[range[0], val], extra]);
  const changeExtra = (val: number | null) => onChange?.([range, val]);

  return (
    <div className={'ant-input-number-range-wrapper'}>
      <InputNumber
        variant={'borderless'}
        className={'range-input'}
        value={value[0][0]}
        placeholder={placeholder?.[0]}
        onChange={changeStart}
        disabled={disabled}
        controls={false}
      />
      <div className={'range-separator'}>
        <SwapRightOutlined />
      </div>
      <InputNumber
        variant={'borderless'}
        className={'range-input'}
        value={value[0][1]}
        placeholder={placeholder?.[1]}
        onChange={changeEnd}
        disabled={disabled}
        controls={false}
      />
      <div className={'range-separator'}>/</div>
      <InputNumber
        variant={'borderless'}
        className={'range-input'}
        value={value[1]}
        placeholder={placeholder?.[2]}
        onChange={changeExtra}
        disabled={disabled}
        controls={false}
      />
    </div>
  );
};

NumberRange.Composite = CompositeNumberRange;

export default NumberRange;
